import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ZapIcon, LockIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-white px-4 md:pt-32 md:pb-20 pt-[5px] pb-[5px]" data-id="element-122">
      <div className="max-w-[800px] mx-auto flex flex-col items-center text-center" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-124">
          <h1 className="font-heading font-bold md:text-4xl text-gray-900 mt-[-60px] mb-[-60px] text-[28px] pt-[80px] pb-[80px]" data-id="element-125">
            Comé Keto, Bajá de peso y{' '}
            <span className="text-[#00A86B]" data-id="element-126">Transformá tu Salud</span> usando
            solo tu Air Fryer
          </h1>

          <p className="md:text-base text-gray-500 max-w-2xl mx-auto text-[14px] mt-[8px] mb-[8px]" data-id="element-127">
            El{' '}
            <span className="text-[#00A86B] font-semibold" data-id="element-128">Recetario Keto</span>{' '}
            pensado para personas que quieren perder peso, controlar la
            diabetes, terminar con la inflamación intestinal,{' '}
            <span className="text-[#00A86B] font-semibold" data-id="element-129">
              tener más energía
            </span>{' '}
            y recuperar su autoestima,{' '}
            <span className="text-[#00A86B] font-semibold" data-id="element-130">
              sin pasar horas en la cocina
            </span>{' '}
            ni necesitar ingredientes imposibles de conseguir.
          </p>

          <div className="flex gap-2 mt-[10px] mb-[10px] flex-col items-center justify-center" data-id="element-131">
            <div className="flex text-[#F59E0B]" data-id="element-132">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-133" />)}
            </div>
            <span className="text-sm font-medium text-[#000000]" data-id="element-134">
              +200 personas usando el recetario
            </span>
          </div>

          <div className="w-full max-w-md mx-auto mb-6" data-id="element-135">
            <CTAButton data-id="element-136">QUIERO MIS RECETAS AHORA →</CTAButton>
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-xs md:text-sm text-gray-600 font-medium mb-12" data-id="element-137">
            <div className="flex items-center gap-1" data-id="element-138">
              <ZapIcon className="w-4 h-4 text-[#00A86B]" data-id="element-139" />
              <span data-id="element-140">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-141">
              <LockIcon className="w-4 h-4 text-[#00A86B]" data-id="element-142" />
              <span data-id="element-143">Pago único</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-144">
              <SmartphoneIcon className="w-4 h-4 text-[#00A86B]" data-id="element-145" />
              <span data-id="element-146">100% digital</span>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="w-full max-w-md mx-auto" data-id="element-147">
            <img src="https://cdn.magicpatterns.com/uploads/vojkkzrFJoNpJyGz41Ux8z/Gemini_Generated_Image_xml3dcxml3dcxml3_(1).png" alt="40 Recetas Keto en Air Fryer - Pack completo con ebook, celular y tablet" className="w-full h-auto rounded-2xl shadow-[0_8px_30px_rgba(0,168,107,0.25)]" data-id="element-148" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}